import React from 'react';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

const NotificationBar = ({
	flashMsgIsOpen,
	flashMsg,
	flashMsgDuration,
	notificationSeverity,
	handleFlashMsgClose
}) => {
	return (
		<Snackbar
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left'
			}}
			open={flashMsgIsOpen}
			autoHideDuration={flashMsgDuration}
			onClose={handleFlashMsgClose}
		>
			<MuiAlert
				onClose={handleFlashMsgClose}
				severity={notificationSeverity}
				variant="standard"
			>
				{flashMsg}
			</MuiAlert>
		</Snackbar>
	);
};

export default NotificationBar;
